import { type MCPServerInfo } from '../../types';

const AtlassianServer: MCPServerInfo = {
  serverId: 'ATLASSIAN',
  name: 'Atlassian (Natoma)',
  slug: 'atlassian',
  description: 'Atlassian MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'mcp/atlassian-mcp-server:0cf20eb',
    commitSha: '0cf20eb',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {
      confluenceUrl: {
        type: 'string',
        description: 'Confluence URL',
        sensitive: false,
        default: 'https://your-company.atlassian.net/wiki'
      },
      confluenceUsername: {
        type: 'string',
        description: 'Confluence Username',
        sensitive: false
      },
      confluenceApiToken: {
        type: 'string',
        description: 'Confluence API Token',
        sensitive: true
      },
      jiraUrl: {
        type: 'string',
        description: 'Jira URL',
        sensitive: false,
        default: 'https://your-company.atlassian.net'
      },
      jiraUsername: {
        type: 'string',
        description: 'Jira Username',
        sensitive: false
      },
      jiraApiToken: {
        type: 'string',
        description: 'Jira API Token',
        sensitive: true
      }
    }
  }
};

export default AtlassianServer;
